import { useSimStatuses } from 'api/index';
import useOpenSessions from 'api/legacy/session/useOpenSessions';
import SimStatusChip from 'components/SimStatusChip/SimStatusChip';
import useSimInventoryFilters from 'hooks/SimInventory/useSimInventoryFilters';
import useUserInfo from 'hooks/User/useUserInfo';
import { useMemo } from 'react';
import type { SimsDaoSim } from 'types/__generated__/SimInventoryApi';
import type {
  CustomCellRendererProps,
  CustomCellRendererReturn,
  SimCellRendererProps,
} from '../SimInventoryTableShared';
import styles from './SimStatusRenderer.module.css';

interface SimStatusRendererProps
  extends CustomCellRendererProps<SimsDaoSim, SimCellRendererProps> {}

const SimStatusRenderer = ({
  value,
  customProps: { segmentName },
}: SimStatusRendererProps): CustomCellRendererReturn => {
  const { isSuperAdmin } = useUserInfo();
  const { filters, hasFilters } = useSimInventoryFilters({
    segmentName,
  });

  const { deviceIdsWithOpenSessions } = useOpenSessions(
    filters.organizationId,
    (isSuperAdmin && hasFilters) || !!filters.organizationId
  );
  const { networkStatusGroups } = useSimStatuses();

  const realNetworkState = useMemo(() => {
    if (
      value?.deviceId &&
      deviceIdsWithOpenSessions.has(value.deviceId) &&
      !networkStatusGroups?.deactivated?.includes(value.networkState as any)
    ) {
      if (networkStatusGroups?.predeployment?.includes(value.networkState as any)) {
        return 'TEST-CONNECTED';
      }
      return 'CONNECTED';
    }
    return value?.networkState;
  }, [
    value?.deviceId,
    deviceIdsWithOpenSessions,
    value?.networkState,
    networkStatusGroups?.predeployment,
    networkStatusGroups?.deactivated,
  ]);

  return <SimStatusChip networkState={realNetworkState} className={styles.wrapper} />;
};

export default SimStatusRenderer;
